import {
  IsString,
  IsNotEmpty,
  MaxLength,
  IsDefined,
  IsArray,
  ValidateNested,
} from 'class-validator'
import { ApiProperty } from '@nestjs/swagger'
import { Type } from 'class-transformer'

/**
 * DTO pour définir une préférence utilisateur
 */
export class SetPreferenceDto {
  @ApiProperty({
    description: 'Clé de la préférence',
    maxLength: 128,
    example: 'theme',
  })
  @IsString()
  @IsNotEmpty()
  @MaxLength(128)
  key!: string

  @ApiProperty({
    description: 'Valeur de la préférence',
    example: 'dark',
  })
  @IsDefined()
  value!: any
}

/**
 * DTO pour définir plusieurs préférences en une seule fois
 */
export class SetPreferencesBulkDto {
  @ApiProperty({
    type: [SetPreferenceDto],
    description: 'Liste de préférences à définir',
  })
  @IsArray()
  @ValidateNested({ each: true })
  @Type(() => SetPreferenceDto)
  preferences!: SetPreferenceDto[]
}
